import { render } from "./IndustrySetup.vue?vue&type=template&id=38a69cfc&scoped=true"
import script from "./IndustrySetup.vue?vue&type=script&lang=js"
export * from "./IndustrySetup.vue?vue&type=script&lang=js"

import "./IndustrySetup.vue?vue&type=style&index=0&id=38a69cfc&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-38a69cfc"]])

export default __exports__